import { BILLING_STATUS } from 'src/features/servicePlanBillingPolicies/utils/types';
import { CURRENCY } from 'src/types';

export enum PAYMENT_TYPE {
    PRE = 'pre',
    POST = 'post',
}

export enum PRICING_MODEL {
    FLAT = 'flat',
    PER_UNIT = 'per_unit',
}

export type ServicePlanItemPricingPolicy = {
    id: string;
    tax_reason: {
        id: string;
        name: string | null;
    },
    status: BILLING_STATUS;
    version_number: number;
    created_at: string;
    modified_at: string;
    valid_from: string;
    payment_type: PAYMENT_TYPE;
    amount: number;
    valid_to: string | null;
    pricing_model: PRICING_MODEL;
    currency?: CURRENCY;
}